import { createSearchParams, useNavigate } from 'react-router-dom';
import { DashboardAnalyticsDateRangeDays, rollingSubmittedDateRange } from './dashboardAnalytics';

export function useDashboardNavigation(dateRangeDays: DashboardAnalyticsDateRangeDays) {
  const navigate = useNavigate();

  const navigateToApplications = ({
    platform = 'all',
    appType = 'all',
    analysisStatus = 'all',
    categories = 'all',
    searchQuery = '',
    riskName = '',
    vendorName = '',
  }: {
    platform?: 'all' | 'android' | 'ios';
    appType?: string;
    analysisStatus?: string;
    categories?: string;
    searchQuery?: string;
    riskName?: string;
    vendorName?: string;
  } = {}) => {
    const { startDate, endDate } = rollingSubmittedDateRange(dateRangeDays);
    const params: Record<string, string> = {
      platform,
      appType,
      startDate,
      endDate,
      analysisStatus,
      categories,
      searchQuery,
    };
    if (riskName) {
      params.riskName = riskName;
    }
    if (vendorName) {
      params.developerName = vendorName;
    }
    navigate({
      pathname: '/applications',
      search: createSearchParams(params).toString(),
    });
  };

  const navigateToAppReport = (analysisId: string) => {
    navigate({
      pathname: '/applications/app-detail-report',
      search: createSearchParams({
        analysisId,
        backQParams: '',
      }).toString(),
    });
  };

  return { navigate, navigateToApplications, navigateToAppReport };
}
